import { FieldWithLabel } from 'components/FieldWithLabel/FieldWithLabel'
import { FileUpload } from 'components/FileUpload/FileUpload'
import Popup from 'components/Popup/Popup'
import { MAX_FILE_SIZE_25_MB } from 'constants/common'
import { BTN_TXT, LABELS } from 'constants/txt'
import { ACCEPT_DOCUMENT_TYPES } from 'features/ContractDetails/ExtendContract/constants'
import { createKeyFromObject, validateFileTypes } from 'helper/common'
import { useMemo } from 'react'
import { UPLOAD_DOCUMENT_CONFIG } from './constants'
import './styles.scss'
import { BUTTON_TYPES } from 'components/Button/constants'
import { Button } from 'components/Button'
import { useUploadAutoContractDocumentsPopup } from './useUploadAutoContractDocumentsPopup'
import { useContractDetailsPopup } from 'features/ContractDetails/Providers/ContractDetailsPopupProvider'
import { useParams } from 'react-router-dom'
import { getAvailableUsersForSignatory } from 'features/ContractDetails/api'
import { ConfigureContractSection } from './ConfigureContractSection'
import { Banner } from 'components/Banner/Banner'
import { CONTRACT_DOCUMENTS_LIMIT_TOOLTIP } from '../constants'

export const UploadMultipleContractDocumentsPopup = () => {
  const {
    documents,
    onClose,
    handleUploadDocument,
    handleDeleteDocument,
    onAddDocument,
    registerForm,
    isUploadLimitReached
  } = useUploadAutoContractDocumentsPopup()

  const {
    uploadAutoContractDocumentPopup: { state }
  } = useContractDetailsPopup()

  const { id } = useParams()

  const UploadDocumentField = useMemo(() => {
    return (
      <FileUpload
        documentType="attachments"
        uploadBtnText={BTN_TXT.UPLOAD}
        handleUploadFile={handleUploadDocument}
        disabled={isUploadLimitReached}
        tooltipText={
          isUploadLimitReached ? CONTRACT_DOCUMENTS_LIMIT_TOOLTIP : undefined
        }
        uploadFilesProps={{
          ...UPLOAD_DOCUMENT_CONFIG,
          onDropAccepted: handleUploadDocument,
          validator: (file) =>
            validateFileTypes(ACCEPT_DOCUMENT_TYPES, file, MAX_FILE_SIZE_25_MB)
        }}
      />
    )
  }, [handleUploadDocument, isUploadLimitReached])

  const Footer = useMemo(() => {
    return (
      <>
        <Button type={BUTTON_TYPES.DEFAULT} upperCase onClick={onClose}>
          {BTN_TXT.CANCEL}
        </Button>
        <Button
          type={BUTTON_TYPES.PRIMARY}
          upperCase
          onClick={onAddDocument}
          disabled={!documents.length}
        >
          {BTN_TXT.ADD}
        </Button>
      </>
    )
  }, [documents.length, onClose, onAddDocument])

  return (
    <Popup
      {...state}
      className="upload-auto-contract-document-popup"
      onCancel={onClose}
      width={676}
      footer={Footer}
    >
      <div className="upload-auto-contract-document-popup-content column gap-32">
        <Banner.Info text="Upload one or more files and set a workflow for each file. Files left without redlining or signature enabled are shared for reference only." />
        <FieldWithLabel title={LABELS.CONTRACTS} requiredSign>
          {documents.map(({ file, uploadedAt }, index) => {
            return (
              <ConfigureContractSection
                key={createKeyFromObject({ file, uploadedAt })}
                file={file}
                className="mb-16"
                onDelete={() => handleDeleteDocument(index)}
                optionsRequest={() => getAvailableUsersForSignatory(id)}
                onFormReady={registerForm}
              />
            )
          })}
          {UploadDocumentField}
        </FieldWithLabel>
      </div>
    </Popup>
  )
}
